<template>
  <boxwrap class="banks--inner">
    <toolbar>
      <toolbar-items class="-searchbar">
        <select-list
          class="toolbar-nav"
          :title="$route.params.status"
          v-model="selectedStatus"
        >
          <select-option
            value="all"
            name="all"
          >
            <span>all</span>
          </select-option>

          <select-option
            value="active"
            name="active"
          >
            <span>active</span>
          </select-option>

          <select-option
            value="inactive"
            name="inactive"
          >
            <span>inactive</span>
          </select-option>

          <select-option
            value="deleted"
            name="deleted"
          >
            <span>deleted</span>
          </select-option>
        </select-list>

        <select-list
          class="toolbar-nav"
          :title="$route.params.type"
          v-model="selectedType"
        >
          <select-option
            value="all"
            name="all"
          >
            <span>all</span>
          </select-option>

          <select-option
            value="bank"
            name="bank"
          >
            <span>bank</span>
          </select-option>

          <select-option
            value="bitcoin"
            name="bitcoin"
          >
            <span>bitcoin</span>
          </select-option>

          <select-option
            value="ewallets"
            name="e-wallets"
          >
            <span>e-wallets</span>
          </select-option>
        </select-list>

        <search
          class="search-bar-wrap -withdropdown"
          :dateBy="dateBy"
          :filterBy="filterBy"
          @refresh="search"
          @trigger="trigger"
          @clear="search"
        >
        </search>

        <button
          class="btn--create"
          title="create"
          @click="showCreate = true"
        >
          <i class="ico--create"></i>
        </button>

        <button
          class="btn--delete"
          title="delete"
          @click="deleteData(selected)"
          v-if="selected.length > 0 &&
            $route.params.status === 'inactive'"
        >
          <i class="ico--delete"></i>
        </button>
        <button
          class="btn--restore"
          title="restore"
          @click="restore(selected)"
          v-if="selected.length > 0 &&
            $route.params.status === 'deleted'"
        >
          <i class="ico--restore"></i>
        </button>
        <button
          class="btn--modify"
          title="modify"
          @click="update(selected, banksData)"
          v-if="selected.length > 0 &&
            $route.params.status !== 'deleted'"
        >
          <i class="ico--save"></i>
        </button>

        <div class="toolbar-rightbtns">
          <button
            class="btn--import-csv"
          >
            <i class="ico--import"></i>
          </button>

          <button
            class="btn--export-csv"
          >
            <i class="ico--export"></i>
          </button>

          <button
            class="btn--tbl-settings"
            @click="showTblSettings = true"
          >
            <i class="ico--settings"></i>
          </button>
        </div>
      </toolbar-items>
    </toolbar>

    <boxwrap-contents
      :class="{'data-loading': showDataLoading}"
    >
      <check-data-list
        label="loading"
        v-if="isDataLoading || isEmpty"
        :isLoading="isDataLoading"
        :isEmpty="isEmpty"
      >
      </check-data-list>

      <tbl
        :scrollable="true"
        :dataLoading="isDataLoading"
      >
        <tbl-inner v-if="!isDataLoading">
          <tbl-head>
            <tbl-row>
              <tbl-td name="checkbox">
                <checkbox>
                  <input type="checkbox" @click="checkAll(banks)">
                </checkbox>
              </tbl-td>

              <tbl-td
                name="no"
                :sort="true"
                @click.native="sort('id')"
                v-if="checkCol('id', tblSetting)"
              >
                no
              </tbl-td>

              <tbl-td
                name="created-at"
                :sort="true"
                @click.native="sort('created_at')"
                v-if="checkCol('created_at', tblSetting)"
              >
                created at
              </tbl-td>

              <tbl-td
                name="bank-name"
                :sort="true"
                @click.native="sort('name')"
                v-if="checkCol('name', tblSetting)"
              >
                bank name
              </tbl-td>

              <tbl-td
                name="updated-at"
                :sort="true"
                @click.native="sort('updated_at')"
                v-if="checkCol('updated_at', tblSetting)"
              >
                updated at
              </tbl-td>

              <tbl-td
                name="deleted-at"
                :sort="true"
                @click.native="sort('deleted_at')"
                v-if="checkCol('deleted_at', tblSetting)"
              >
                deleted at
              </tbl-td>

              <tbl-td
                name="type"
                :sort="true"
                @click.native="sort('type_id')"
                v-if="checkCol('type_id', tblSetting)"
              >
                type
              </tbl-td>

              <tbl-td
                name="status"
                :sort="true"
                @click.native="sort('status')"
                v-if="checkCol('status', tblSetting) "
              >
                status
              </tbl-td>

              <tbl-td
                name="delete-restore"
                v-if="checkPermission &&
                  ($route.params.status === 'inactive' ||
                  $route.params.status === 'deleted')"
              >
              </tbl-td>
            </tbl-row>
          </tbl-head>

          <tbl-body>
            <tbl-row
              v-for="(bank, index) in banksData"
              :key="index"
              @click.native="showModifyPopUp(bank)"
              :class="{'is-deleted': bank.deleted_at}"
            >
              <tbl-td name="checkbox">
                <checkbox
                  @click.native.stop
                >
                  <input
                    type="checkbox"
                    v-model="selected"
                    :value="bank.id"
                  >
                </checkbox>
              </tbl-td>

              <tbl-td
                name="no"
                v-if="checkCol('id', tblSetting)"
              >
                {{ generateNumber(index, params.page, params.rows, params.sort, count || 0) }}
              </tbl-td>

              <tbl-td
                class="created-at"
                v-if="checkCol('created_at', tblSetting)"
              >
                {{ bank.created_at | date }}
              </tbl-td>

              <tbl-td
                name="bank-name"
                v-if="checkCol('name', tblSetting)"
              >
                {{ bank.name }}
              </tbl-td>

              <tbl-td
                class="updated-at"
                v-if="checkCol('updated_at', tblSetting)"
              >
                {{ bank.updated_at | date }}
              </tbl-td>

              <tbl-td
                class="deleted-at"
                v-if="checkCol('deleted_at', tblSetting)"
              >
                {{ bank.deleted_at | date }}
              </tbl-td>

              <tbl-td
                name="type"
                v-if="checkCol('type_id', tblSetting)"
              >
                <select-list
                  :title="bankTypes | typeName(bank.type_id)"
                  :withReset="true"
                  v-model="bank.type_id"
                  @reset="resetTrigger(bank)"
                >
                  <select-option
                    v-for="(type, idx) in bankTypes"
                    :key="idx"
                    :value="type.id"
                    :name="type.name"
                    @click.native="setSelected(bank)"
                  >
                    {{ type.name }}
                  </select-option>
                </select-list>
              </tbl-td>

              <tbl-td
                name="status"
                v-if="checkCol('status', tblSetting)"
              >
                <select-list
                  :title="bank.status ? 'active' : 'inactive'"
                  :withReset="true"
                  v-model="bank.status"
                  @reset="resetTrigger(bank)"
                >
                  <select-option
                    :value="false"
                    :name="'inactive'"
                    v-if="bank.status"
                    @click.native="setSelected(bank)"
                  >
                    inactive
                  </select-option>
                  <select-option
                    :value="true"
                    :name="'active'"
                    v-if="!bank.status"
                    @click.native="setSelected(bank)"
                  >
                    active
                  </select-option>
                </select-list>
              </tbl-td>

              <tbl-td
                class="delete-restore"
                v-if="checkPermission &&
                  ($route.params.status === 'inactive' ||
                  $route.params.status === 'deleted')"
              >
                <button
                  class="btn--restore"
                  v-if="bank.deleted_at"
                  @click.stop="restore(bank.id)"
                >
                  <i class="ico--restore"></i>
                </button>

                <button
                  class="btn--delete"
                  v-else
                  @click.stop="deleteData(bank.id)"
                >
                  <i class="ico--delete"></i>
                </button>
              </tbl-td>
            </tbl-row>
          </tbl-body>
        </tbl-inner>

        <tbl-footer>
          <pagination
            v-model="params.page"
            :total="count"
            :limit="params.rows"
            :rows="params.rows"
            @page="trigger">
          </pagination>
        </tbl-footer>
      </tbl>
    </boxwrap-contents>

    <modal
      class="modal--create-bank"
      :title="'create bank'"
      :activate="showCreate"
      :draggable="true"
      :bodyOverflow="true"
      v-if="showCreate"
      @activate="event => { showCreate = event }"
    >
      <template slot="body">
        <div class="form-con">
          <div class="form-items">
            <div class="form-lbl"><span>bank type</span></div>
            <div class="form-data">
              <select-list
                :title="bankTypes | typeName(createParams.type_id)"
                :withReset="true"
                v-model="createParams.type_id"
              >
                <select-option
                  v-for="(type, idx) in bankTypes"
                  :key="idx"
                  :value="type.id"
                >
                  {{ type.name }}
                </select-option>
              </select-list>
            </div>
          </div>
          <div class="form-items">
            <div class="form-lbl"><span>bank name</span></div>
            <div class="input-wrap">
              <input
                type="text"
                v-model="createParams.name"
              >
            </div>
          </div>
        </div>
      </template>

      <template slot="footer">
        <button
          class="btn--confirm -withlabel"
          @click="create()"
        >
          <i class="ico--save"></i>
          <span>create</span>
        </button>
      </template>
    </modal>

    <modal
      class="modal--modify-bank"
      :title="'modify bank'"
      :activate="showUpdate"
      :draggable="true"
      :bodyOverflow="true"
      v-if="showUpdate"
      @activate="event => {
        showUpdate = event,
        hideModifyPopUp(updateParams)
      }"
    >
      <template slot="body">
        <div class="form-con">
          <div class="form-items">
            <div class="form-lbl"><span>Created at</span></div>
            <div class="form-data">
              <div class="input-wrap">
                <span>{{ updateParams.created_at | date }}</span>
              </div>
            </div>
          </div>

          <div class="form-items">
            <div class="form-lbl"><span>Updated at</span></div>
            <div class="form-data">
              <div class="input-wrap">
                <span>{{ updateParams.updated_at | date }}</span>
              </div>
            </div>
          </div>

          <div class="form-items">
            <div class="form-lbl"><span>Deleted at</span></div>
            <div class="form-data">
              <div class="input-wrap">
                <span>{{ updateParams.deleted_at | date }}</span>
              </div>
            </div>
          </div>

          <div class="form-items">
            <div class="form-lbl"><span>bank name</span></div>
            <div class="form-data">
              <div class="input-wrap">
                <input
                  type="text"
                  v-model="updateParams.name"
                >
              </div>
            </div>
          </div>

          <div class="form-items">
            <div class="form-lbl"><span>bank type</span></div>
            <div class="form-data">
              <select-list
                :title="bankTypes | typeName(updateParams.type_id)"
                :withReset="true"
                v-model="updateParams.type_id"
              >
                <select-option
                  v-for="(type, idx) in bankTypes"
                  :key="idx"
                  :value="type.id"
                >
                  {{ type.name }}
                </select-option>
              </select-list>
            </div>
          </div>

          <div class="form-items">
            <div class="form-lbl"><span>status</span></div>
            <div class="form-data">
              <select-list
                :title="updateParams.status ? 'active' : 'inactive'"
                :withReset="true"
                v-model="updateParams.status"
              >
                <select-option
                  :value="false"
                  :name="'inactive'"
                  v-if="updateParams.status"
                >
                  inactive
                </select-option>
                <select-option
                  :value="true"
                  :name="'active'"
                  v-if="!updateParams.status"
                >
                  active
                </select-option>
              </select-list>
            </div>
          </div>
        </div>
      </template>

      <template slot="footer">
        <button
          class="btn--modify -withlabel"
          @click="update(selected,banksData,updateParams)"
        >
          <i class="ico--save"></i>
          <span>modify</span>
        </button>
      </template>
    </modal>

    <table-settings
      :showTblSettings="showTblSettings"
      :allCols="allCols"
      :tblSetting="tblSetting"
      :activate="showTblSettings"
      v-if="modConfig.tableConfig"
      @activate="showTblSettings = $event"
      @load="showLoad()"
    >
    </table-settings>
  </boxwrap>
</template>

<script>
import { mapState, mapActions } from 'vuex'

//= mixins
import { getListStatus } from '@/assets/js/mixins/common/GetListStatus'
import { checkAll } from '@/assets/js/mixins/base/CheckAll'
import { swal } from '@/assets/js/mixins/base/Swal'

import Modal from '@/components/base/Modal'
import Checkbox from '@/components/base/Checkbox'
import Pagination from '@/components/base/Pagination'
import Search from '@/components/base/search/Search'
import CheckDataList from '@/components/base/CheckDataList'

import '@/components/base/table/Table'
// import '@/components/layout/boxwrap/Boxwrap'
import '@/components/base/select/Select'
import '@/components/common/table-settings/TableSettings'

export default {
  components: {
    Modal,
    Checkbox,
    Pagination,
    Search,
    CheckDataList
  },

  mixins: [ checkAll, getListStatus, swal ],

  filters: {
    typeName (typeList, param) {
      let name

      typeList.forEach((type) => {
        if (type.id === param) {
          name = type.name
        }
      })

      return name
    }
  },

  data () {
    let params = Object.assign(
      {
        page: 1,
        rows: 50,
        filter_by: '',
        q: '',
        sort_by: 'id',
        sort: 'desc',
        date_from: '',
        date_to: ''
      },
      this.$route.query
    )

    return {
      params,
      createParams: {
        name: '',
        type_id: ''
      },
      updateParams: {
        id: '',
        name: '',
        type_id: null,
        status: null
      },
      filterBy: [
        {
          value: 'name',
          display: 'Bank Name'
        }
      ],
      showCreate: false,
      showUpdate: false,
      selectAll: false,
      selected: [],
      banksData: [],

      isDataLoading: true,
      isEmpty: false,
      showDataLoading: false,
      status: 'all',
      type: 'all',

      showTblSettings: false,
      tblSetting: 'banks',

      dateBy: [
        {
          value: 'created_at',
          display: 'created at'
        },

        {
          value: 'updated_at',
          display: 'updated at'
        },

        {
          value: 'deleted_at',
          display: 'deleted at'
        }
      ],

      allCols: [
        {
          display: 'no',
          value: 'id'
        },
        {
          display: 'created at',
          value: 'created_at'
        },
        {
          display: 'bank name',
          value: 'name'
        },
        {
          display: 'type',
          value: 'type_id'
        },
        {
          display: 'status',
          value: 'status'
        },
        {
          display: 'updated at',
          value: 'updated_at'
        },
        {
          display: 'deleted at',
          value: 'deleted_at'
        }
      ]
    }
  },

  computed: {
    ...mapState('bank', ['banks', 'count', 'bankTypes']),
    checkPermission () {
      let permission = JSON.parse(window.localStorage.permission)
      let dbKey = this.$route.meta.dbKey
      let obj

      for (let key in permission) {
        if (dbKey === key) {
          obj = permission[key]
        }
      }

      return obj === 'rw' ? 1 : ''
    }
  },

  watch: {
    $route ($router) {
      if (!this.showDataLoading) {
        this.showDataLoading = true
      }
      this.search(this.generate($router.query))
    }
  },

  created () {
    if (this.$route.params.status === undefined) {
      this.$router.push(`${this.$route.path}/all/all`)
    }

    if (this.$route.params.type === undefined) {
      this.$router.push(`${this.$route.path}/all/all`)
    }

    this.params = this.generate(this.params)
    this.search()
  },

  methods: {
    ...mapActions('bank',
      ['get', 'delete', 'recover']),
    ...mapActions('bank', { updateBank: 'update' }),
    ...mapActions('bank', { createBank: 'create' }),

    trigger (q) {
      let s = this.$route.params.status
      let t = this.$route.params.type
      this.params = q || this.params
      this.$router.push({ path: `/banks/${s}/${t}`, query: this.params })
    },

    async search (q) {
      this.params = q || this.params
      this.status = this.$route.params.status
      this.type = this.$route.params.type

      this.selected = []

      // == flags reset
      this.isEmpty = false
      if (!this.showDataLoading) {
        this.isDataLoading = true
      }

      await this.get({
        status: this.status,
        type: this.type,
        params: this.params
      })

      this.isDataLoading = false
      this.showDataLoading = false
      this.banksData = JSON.parse(JSON.stringify(this.banks))

      if (!this.banks.length) {
        this.isEmpty = true
      }
    },

    async create () {
      let success = async () => {
        let result = await this.createBank(this.createParams)

        if (result.status === 201) {
          this.$alert('success', 'You have successfully created a bank.', {}, '', 'Success')
          this.resetParams('create')
          this.search()
        }
      }

      if (this.createParams.name.trim() === '' || this.createParams.type_id === '') {
        this.$alert('error', 'All fields required.', {}, '', 'Error')
        return
      }

      this.$alert('prompt', 'Are you sure you want to continue?', {}, { success }, 'Create Bank')
    },

    async update (selected, banks, bank) {
      let success = async () => {
        let params = []
        let result

        if (!bank) {
          banks.forEach((data) => {
            selected.forEach((v, k) => {
              if (data.id === v) {
                params.push(Object.assign({}, data,
                  { type_name: undefined,
                    created_at: undefined,
                    updated_at: undefined,
                    deleted_at: undefined,
                    status: data.status ? 1 : 0
                  }))
              }
            })
          })
        } else {
          banks.forEach((data) => {
            if (data.id === bank.id) {
              params.push(Object.assign({}, data,
                { type_name: undefined,
                  created_at: undefined,
                  updated_at: undefined,
                  deleted_at: undefined,
                  status: data.status ? 1 : 0,
                  name: bank.name
                }))
            }
          })
        }

        result = await this.updateBank(params)

        if (result.status === 204) {
          this.$alert('success', 'You have successfully modified the bank(s).', {}, '', 'Success')
          this.resetParams('update')
          this.search()
        }
      }

      this.$alert('prompt', 'Are you sure you want to modify the following bank(s)?',
        {}, { success }, 'Modify Bank')
    },

    async restore (ids) {
      let success = async () => {
        let params = []
        let result

        if (!Array.isArray(ids)) {
          params.push({
            id: ids,
            data: { deleted_at: null }
          })
        } else {
          ids.map((id) => {
            params.push({
              id: id,
              data: { deleted_at: null }
            })
          })
        }

        result = await this.recover(params)

        if (result.status === 204) {
          this.$alert('success', 'You have successfully restored the bank(s).', {}, '', 'Success')
          this.resetParams()
          this.search()
        }
      }

      this.$alert('prompt', 'Are you sure you want to restore bank(s)?', {}, { success }, 'Restore Bank')
    },

    async deleteData (ids) {
      let success = async () => {
        let params = []
        let result

        if (!Array.isArray(ids)) {
          params.push(ids)
        } else {
          params = ids
        }

        result = await this.delete(params)

        if (result.status === 202) {
          this.$alert('success', 'You have successfully removed the bank(s).', {}, '', 'Success')
          this.search()
          this.resetParams()
        }
      }

      this.$alert('prompt', 'Are you sure you want to remove bank(s)?', {}, { success }, 'Remove Bank')
    },

    resetParams (data = null) {
      if (data === 'filter') {
        this.params = {
          page: 1,
          rows: 50,
          filter_by: '',
          q: '',
          sort_by: 'id',
          sort: 'desc',
          date_from: '',
          date_to: ''
        }
      }

      if (data === 'create') {
        this.createParams = {
          name: '',
          type_id: ''
        }
        this.showCreate = false
      }

      if (data === 'update') {
        this.updateParams = {
          id: '',
          name: ''
        }
        this.showUpdate = false
      }

      this.selected = []
      this.selectAll = false
    },

    setSelected (bank) {
      this.$nextTick(() => {
        let result = this.banks.find((row) => {
          return row.id === bank.id
        })

        let idx = this.selected.indexOf(bank.id)

        if (bank.type_id === result.type_id &&
            bank.status === result.status &&
            idx > -1) {
          this.selected.splice(idx, 1)
          return
        }

        if (bank.type_id === result.type_id &&
          bank.status === result.status) {
          return
        }

        this.selected.push(bank.id)
        this.selected = this.selected.filter((val, idx, arr) => {
          return arr.indexOf(val) === idx
        })
      })
    },

    sort (sortBy) {
      if (this.params.sort === 'asc') {
        this.params.sort = 'desc'
      } else {
        this.params.sort = 'asc'
      }

      this.params.sort_by = sortBy

      if (!this.showDataLoading) {
        this.showDataLoading = true
      }

      this.search()
    },

    showModifyPopUp (bank) {
      if (this.checkPermission) {
        this.selected.push(bank.id)
        this.showUpdate = true
        this.updateParams = bank
      }
    },

    hideModifyPopUp (data) {
      let idx = this.selected.indexOf(data.id)

      this.selected.splice(idx, 1)
    },

    resetTrigger (bank) {
      this.$nextTick(() => {
        let count = 0
        let idx = this.selected.indexOf(bank.id)

        let result = this.banks.find((row) => {
          return row.id === bank.id
        })

        if (result.type_id !== bank.type_id) {
          count += 1
        }

        if (result.status !== bank.status) {
          count += 1
        }

        if (count === 0 && idx > -1) {
          this.selected.splice(idx, 1)
        }
      })
    }
  }
}
</script>
